import React from "react";
import CountUp from 'react-countup';

const Email = () => {
  return (
    <>
      <section className="blog_wrapper">
        <div className="newsletter_wrapper">
          <div className="container py-5">
            <div className="row">
              <div className="col-12">
                <div className="counter text-center">
                  <div className="couter-content">
                    <h3 className="text-white counter-number"><CountUp end={2021}  duration={5.75}/><span></span></h3>
                    <p>Date of Establishment</p>
                  </div>
                  <div className="couter-content">
                    <h3 className="text-white counter-number"><CountUp end={25}  duration={5.75}/><span> +</span></h3>
                    <p>Employees</p>
                  </div>
                  <div className="couter-content">
                    <h3 className="text-white counter-number"><CountUp end={7500}  duration={5.75}/><span> +</span></h3>
                    <p>Happy Parents</p>
                  </div>
                  <div className="couter-content">
                    <h3 className="text-white counter-number"><CountUp end={300}  duration={5.75}/><span> +</span></h3>
                    <p>Partners</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Email;
